export * from './matchSquadPlayer1/MatchSquadPlayer';
export * from './playerMeta/PlayerMeta';
export * from './managerMeta/ManagerMeta';
export * from './playerAvatar/PlayerAvatar';
export * from './playerFeedback/PlayerFeedback';



// WEBPACK FOOTER //
// ./src/components/cards/index.js